import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: {
    episodes: [],
    episodesLoading: true,
    episodesError: null
  },
  mutations: {
    SET_EPISODES(state, episodes) {
      state.episodes = episodes;
    },
    SET_EPISODES_LOADING(state, loading) {
      state.episodesLoading = loading;
    },
    SET_EPISODES_ERROR(state, error) {
      state.episodesError = error;
    }
  },
  actions: {
    async fetchEpisodes({ commit }) {
      commit('SET_EPISODES_LOADING', true);
      commit('SET_EPISODES_ERROR', null);
      try {
        const apiUrl = 'https://api.spreaker.com/v2/shows/4534835/episodes?limit=99';
        const response = await axios.get(apiUrl);
        const episodes = response.data.response.items.map(item => ({
          id: item.episode_id,
          title: item.title,
          description: item.description,
          length: item.duration,
          audio: item.download_url
        }));

        commit('SET_EPISODES', episodes);
      } catch {
        commit('SET_EPISODES_ERROR', 'Episodes are temporarily unavailable.');
      } finally {
        commit('SET_EPISODES_LOADING', false);
      }
    }
  }
});
